<template>
  <div class="notifications-indicator">
    <b-img :src="require('../assets/img/notifications.svg')"/>
    <div class="badge" v-if="notifications > 0">
      {{ number }}
    </div>
  </div>
</template>

<script>
  export default {
    name: "NavbarNotifications",
    props: ['notifications'],
    computed: {
      number() {
        if (this.notifications > 99) {
          return '99+'
        }
        return this.notifications
      }
    }
  }
</script>

<style lang="scss" scoped>
  .notifications-indicator {
    position: relative;
    width: 30px;
    height: 30px;
    display: flex;
    img {
      width: 25px;
    }
    .badge {
      border-radius: 50%;
      position: absolute;
      top: 0;
      right: 0;
      background: $yellow;
      color: black;
    }
  }
</style>
